import { find, matches } from 'lodash';
import { CalibrationData } from '../../team-apis/otterdam/calibration-data';
import { Input } from '../../team-apis/otterdam/input';
import { Task } from '../../team-apis/otterdam/task';

export function getCalibrationData(
  task: Task,
  inputs: Input[],
  outputId: number,
): CalibrationData | undefined {
  const calibrationInput = find(
    inputs,
    matches({
      sub_type: 'calibration_parameters',
      output_id: outputId,
    }),
  );

  if (calibrationInput && task.data[calibrationInput.name]) {
    return JSON.parse(task.data[calibrationInput.name]);
  }

  return undefined;
}
